import { useState } from "react";
import { LOGO_SECONDARY } from "@/lib/constants";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { href: "#builder", label: "Builder" },
  { href: "#how-it-works", label: "How it works" },
  { href: "#contact", label: "Contact" },
];

export const Header = ({ onStartBuilder }) => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 border-b-2 border-black bg-white"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-3 md:px-10 md:py-4">
        <a
          href="/"
          data-testid="header-logo-link"
          className="flex items-center gap-3"
        >
          <img
            src={LOGO_SECONDARY}
            alt="Home Guard Developments"
            className="h-11 w-11 border-2 border-black bg-black object-contain p-1 md:h-12 md:w-12"
            data-testid="header-logo-img"
          />
          <div className="flex flex-col leading-none">
            <span className="font-display text-[15px] font-black tracking-tight text-black md:text-base">
              HOME GUARD
            </span>
            <span className="font-display text-[10px] font-bold tracking-[0.25em] text-[#9D4CDD] md:text-[11px]">
              DEVELOPMENTS
            </span>
          </div>
        </a>

        <nav
          data-testid="desktop-nav"
          className="hidden items-center gap-10 md:flex"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-display text-xs font-bold uppercase tracking-[0.2em] text-black transition-colors hover:text-[#9D4CDD]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            data-testid="start-builder-cta-header"
            onClick={onStartBuilder}
            className="hidden border-2 border-black bg-black px-5 py-3 font-display text-xs font-bold uppercase tracking-[0.2em] text-white transition-all hover:bg-[#9D4CDD] hover:border-[#9D4CDD] md:inline-flex"
          >
            Start Builder →
          </button>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center border-2 border-black md:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-nav"
          className="border-t-2 border-black bg-white md:hidden"
        >
          <div className="flex flex-col gap-1 px-5 py-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="border-b border-black/10 py-3 font-display text-sm font-bold uppercase tracking-[0.2em] text-black"
              >
                {l.label}
              </a>
            ))}
            <button
              type="button"
              data-testid="start-builder-cta-mobile"
              onClick={() => {
                setOpen(false);
                onStartBuilder?.();
              }}
              className="mt-3 border-2 border-black bg-black px-5 py-3 font-display text-xs font-bold uppercase tracking-[0.2em] text-white"
            >
              Start Builder →
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
